import { render } from "./ReleaseAddComponent.vue?vue&type=template&id=183ebb35&scoped=true"
import script from "./ReleaseAddComponent.vue?vue&type=script&lang=js"
export * from "./ReleaseAddComponent.vue?vue&type=script&lang=js"

import "./ReleaseAddComponent.vue?vue&type=style&index=0&id=183ebb35&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183ebb35"]])

export default __exports__